import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { IconBg } from '@/components/ui/IconBg'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { hexToHslaOrPassthrough } from '@/lib/utils'
import { ReactNode } from 'react'
import { ColumnMetadataConfig, TableColumn } from '../types-v4'
import { getMetadataForValue } from './getMetadataForValue'

/**
 * Renders an icon with optional background, color, and tooltip based on metadata
 */
// export const renderIcon = (value: unknown, column: TableColumn): ReactNode => {
export const RenderIcon = ({ value, metadata }: { value: unknown; metadata?: ColumnMetadataConfig }): ReactNode => {
  // if (!column.columnConfig.metadata?.fields) {
  if (!metadata?.fields) {
    return null
  }

  const metadataValue = getMetadataForValue(value as string, metadata.fields)

  if (!metadataValue.icon) {
    return null
  }

  const bgStyle = metadataValue.color ? { backgroundColor: hexToHslaOrPassthrough(metadataValue.color, 0.05) } : {}

  const iconStyle = metadataValue.color ? { color: metadataValue.color } : {}

  const iconWithBg = (
    <IconBg style={bgStyle} className="shadow">
      <DynamicIcon size={16} iconName={metadataValue.icon} style={iconStyle} />
    </IconBg>
  )

  if (metadataValue.tooltip) {
    return (
      <TooltipButton side="left" tooltip={metadataValue.tooltip}>
        {iconWithBg}
      </TooltipButton>
    )
  }

  return iconWithBg
}
